// @core/api/endpoints/form/get_form_analytics.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormAnalyticsResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Get form analytics
 * Returns aggregated analytics for a form including submission counts, completion rates, and field-level statistics.
 */
export async function GetFormAnalytics(
  form_id: string,
  options?: RequestOptions
): Promise<FormAnalyticsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/analytics`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.get<FormAnalyticsResponse>(requestPath, { ...requestOptions });
}
